import { Box } from 'bonfire-kindling';

const Container = props => (
  <Box
    display="flex"
    flexDirection="column"
    alignItems="center"
    justifyContent="flex-start"
    p={4}
    height="100%"
    {...props}
  />
);

export default Container;
